import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetHiddenExcel = (params?: { Key?: string }): Promise<any> =>
    request({
        url: ApiURL.Query.GetHiddenExcel,
        method: RequestType.GET,
        params,
    });

const GetHiddenExcelTables = (params?: { Name?: string; CountryId?: number }): Promise<any> =>
    request({
        url: ApiURL.Query.GetHiddenExcelTables,
        method: RequestType.GET,
        params,
    });

const GetHiddenExcelTableById = (id: number): Promise<any> =>
    request({
        url: `${ApiURL.Query.GetHiddenExcelTableById}/${id}`,
        method: RequestType.GET,
    });

const HiddenExcelQuery = {
    GetHiddenExcel,
    GetHiddenExcelTables,
    GetHiddenExcelTableById,
};

export default HiddenExcelQuery;
